// extracted by mini-css-extract-plugin
module.exports = {"mylist":"FacebookEventList_mylist__1WLME"};